import { render } from "./index.vue?vue&type=template&id=a4a83426&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a4a83426&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a4a83426"

export default script